@if(formGroup(); as form)
{   
    @if(form.get(id()); as nameControl)
    {    
        <div [id]="id() + '-errors'" class="invalid-feedback d-block" role="alert">
            @if(nameControl.invalid && (nameControl.dirty || nameControl.touched))
            {
                @if (nameControl.errors['required'])
                {                            
                    <required-validation-error [label]="label()" />
                }
                @if (nameControl.errors['nameTaken'])
                {
                    <name-taken-validation-error [label]="label()" />
                }    
                
                @if (nameControl.errors['email'])
                {
                    <email-validation-error [label]="label()" />
                }
                
                @if (nameControl.errors['pattern'])
                {
                    <pattern-validation-error [label]="label()" />
                }
            }
       </div>
    }
    @else {
        <div class="valid-feedback d-block" role="alert">&nbsp;</div>
    }
}